import { greateAmericanTypeOfOperationAutomobileHauler, greateAmericanTypeOfOperationCourier, greateAmericanTypeOfOperationDoubleTrailers, greateAmericanTypeOfOperationHouseholdGoods, greateAmericanTypeOfOperationRefrigeratedFreight } from '../constants/greateAmerican';
import { BusinessTypeLimitedCompany, BusinessTypeLimitedLiabilityCompany, BusinessTypePartnershipCompany, BusinessTypeSoleTrader } from '../localeConstants/quote';
import { getLocalTranslation } from '../utils/i18nKit';
export var getTypeOfOperationList = function getTypeOfOperationList() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return [{
    value: greateAmericanTypeOfOperationCourier,
    label: $t('kit:courier')
  }, {
    value: greateAmericanTypeOfOperationHouseholdGoods,
    label: $t('kit:household_removals')
  }, {
    value: greateAmericanTypeOfOperationAutomobileHauler,
    label: $t('kit:automobile_hauler')
  }, {
    value: 'other',
    label: $t('kit:other')
  }];
};
export var getOtherTypeOfOperationList = function getOtherTypeOfOperationList() {
  var _getLocalTranslation2 = getLocalTranslation(),
      $t = _getLocalTranslation2.$t;

  return [{
    value: 'containerizedFreight',
    label: $t('kit:contanerized_freight')
  }, {
    value: greateAmericanTypeOfOperationDoubleTrailers,
    label: $t('kit:double_trailers')
  }, {
    value: 'flatBed',
    label: $t('kit:flat_bed')
  }, {
    value: 'mobileHauler',
    label: $t('kit:mobile_home_hauler')
  }, {
    value: greateAmericanTypeOfOperationRefrigeratedFreight,
    label: $t('kit:refridgerated_freight')
  } // {
  //   value: 'Wrecker/ Tower',
  //   label: $t('kit:wrecker_tower'),
  // },
  ];
};
/**
 * Greate american: Average radius operation
 */

export var getAverageRadiusOfOperationList = function getAverageRadiusOfOperationList() {
  var _getLocalTranslation3 = getLocalTranslation(),
      $t = _getLocalTranslation3.$t;

  return [{
    value: '150',
    label: "0-150 ".concat($t('kit:miles'))
  }, {
    value: '300',
    label: "151-300 ".concat($t('kit:miles'))
  }, {
    value: '500',
    label: "301-500 ".concat($t('kit:miles'))
  }, {
    value: '1000',
    label: "501-1000 ".concat($t('kit:miles'))
  }, {
    value: '1000PLUS',
    label: "1001+ ".concat($t('kit:miles'))
  }];
};
/**
 * Greate american: business type
 */

export var getGreateAmericanBusinessTypeList = function getGreateAmericanBusinessTypeList() {
  var _getLocalTranslation4 = getLocalTranslation(),
      $t = _getLocalTranslation4.$t;

  return [{
    value: BusinessTypeSoleTrader,
    label: $t('kit:sole_proprietorship')
  }, {
    value: BusinessTypePartnershipCompany,
    label: $t('kit:partnership')
  }, {
    value: BusinessTypeLimitedCompany,
    label: $t('kit:corporation')
  }, {
    value: BusinessTypeLimitedLiabilityCompany,
    label: $t('kit:limited_liability_company')
  }];
};
/**
 * Greate american: Years of experience
 */

export var getGreateAmericanYearsOfExperienceList = function getGreateAmericanYearsOfExperienceList() {
  var _getLocalTranslation5 = getLocalTranslation(),
      $t = _getLocalTranslation5.$t;

  return [{
    value: 'YIB4',
    label: $t('kit:yearsOfExperience.experience_1')
  }, {
    value: 'YIB0',
    label: $t('kit:yearsOfExperience.experience_2')
  }, {
    value: 'YIB1',
    label: $t('kit:yearsOfExperience.experience_3')
  }, {
    value: 'YIB2',
    label: $t('kit:yearsOfExperience.experience_4')
  }, {
    value: 'YIB3',
    label: $t('kit:yearsOfExperience.experience_5')
  }];
};
/**
 * Greate american: State
 */

export var getGreateAmericanStateList = function getGreateAmericanStateList() {
  var _getLocalTranslation6 = getLocalTranslation(),
      $t = _getLocalTranslation6.$t;

  return [{
    value: 'AL',
    label: $t('kit:stateInfo.alabama')
  }, {
    value: 'AK',
    label: $t('kit:stateInfo.alaska')
  }, {
    value: 'AZ',
    label: $t('kit:stateInfo.arizona')
  }, {
    value: 'AR',
    label: $t('kit:stateInfo.arkansas')
  }, {
    value: 'CA',
    label: $t('kit:stateInfo.california')
  }, {
    value: 'CO',
    label: $t('kit:stateInfo.colorado')
  }, {
    value: 'CT',
    label: $t('kit:stateInfo.connecticut')
  }, {
    value: 'DC',
    label: $t('kit:stateInfo.district_of_columbia')
  }, {
    value: 'DE',
    label: $t('kit:stateInfo.delaware')
  }, {
    value: 'FL',
    label: $t('kit:stateInfo.florida')
  }, {
    value: 'GA',
    label: $t('kit:stateInfo.georgia')
  }, {
    value: 'HI',
    label: $t('kit:stateInfo.hawaii')
  }, {
    value: 'ID',
    label: $t('kit:stateInfo.idaho')
  }, {
    value: 'IL',
    label: $t('kit:stateInfo.illinois')
  }, {
    value: 'IN',
    label: $t('kit:stateInfo.indiana')
  }, {
    value: 'IA',
    label: $t('kit:stateInfo.iowa')
  }, {
    value: 'KS',
    label: $t('kit:stateInfo.kansas')
  }, {
    value: 'KY',
    label: $t('kit:stateInfo.kentucky')
  }, {
    value: 'LA',
    label: $t('kit:stateInfo.louisiana')
  }, {
    value: 'ME',
    label: $t('kit:stateInfo.maine')
  }, {
    value: 'MD',
    label: $t('kit:stateInfo.maryland')
  }, {
    value: 'MA',
    label: $t('kit:stateInfo.massachusetts')
  }, {
    value: 'MI',
    label: $t('kit:stateInfo.michigan')
  }, {
    value: 'MN',
    label: $t('kit:stateInfo.minnesota')
  }, {
    value: 'MS',
    label: $t('kit:stateInfo.mississippi')
  }, {
    value: 'MO',
    label: $t('kit:stateInfo.missouri')
  }, {
    value: 'MT',
    label: $t('kit:stateInfo.montana')
  }, {
    value: 'NE',
    label: $t('kit:stateInfo.nebraska')
  }, {
    value: 'NV',
    label: $t('kit:stateInfo.nevada')
  }, {
    value: 'NH',
    label: $t('kit:stateInfo.new_hampshire')
  }, {
    value: 'NJ',
    label: $t('kit:stateInfo.new_jersey')
  }, {
    value: 'NM',
    label: $t('kit:stateInfo.new_mexico')
  }, {
    value: 'NY',
    label: $t('kit:stateInfo.new_york')
  }, {
    value: 'NC',
    label: $t('kit:stateInfo.north_carolina')
  }, {
    value: 'ND',
    label: $t('kit:stateInfo.north_dakota')
  }, {
    value: 'OH',
    label: $t('kit:stateInfo.ohio')
  }, {
    value: 'OK',
    label: $t('kit:stateInfo.oklahoma')
  }, {
    value: 'OR',
    label: $t('kit:stateInfo.oregon')
  }, {
    value: 'PA',
    label: $t('kit:stateInfo.pennsylvania')
  }, {
    value: 'RI',
    label: $t('kit:stateInfo.rhode_island')
  }, {
    value: 'SC',
    label: $t('kit:stateInfo.south_carolina')
  }, {
    value: 'SD',
    label: $t('kit:stateInfo.south_dakota')
  }, {
    value: 'TN',
    label: $t('kit:stateInfo.tennessee')
  }, {
    value: 'TX',
    label: $t('kit:stateInfo.texas')
  }, {
    value: 'UT',
    label: $t('kit:stateInfo.utah')
  }, {
    value: 'VT',
    label: $t('kit:stateInfo.vermont')
  }, {
    value: 'VA',
    label: $t('kit:stateInfo.virginia')
  }, {
    value: 'WA',
    label: $t('kit:stateInfo.washington')
  }, {
    value: 'WV',
    label: $t('kit:stateInfo.west_virginia')
  }, {
    value: 'WI',
    label: $t('kit:stateInfo.wisconsin')
  }, {
    value: 'WY',
    label: $t('kit:stateInfo.wyoming')
  }];
};
/**
 * Greate american: Cover
 */

export var getGreateAmericanCoverMap = function getGreateAmericanCoverMap() {
  var _getLocalTranslation7 = getLocalTranslation(),
      $t = _getLocalTranslation7.$t;

  return {
    prePowerUnit: {
      value: 'pre-power-unit',
      label: $t('kit:greateAmericanCover.motor_truck_cargo')
    },
    deductible: {
      value: 'deductible',
      label: $t('kit:greateAmericanCover.deductible')
    },
    reloading: {
      value: 'reloading',
      label: $t('kit:greateAmericanCover.reloading')
    },
    debrisRemoval: {
      value: 'debris-removal',
      label: $t('kit:greateAmericanCover.debris_removal')
    },
    earnedFreight: {
      value: 'earned-freight',
      label: $t('kit:greateAmericanCover.earned_freight')
    },
    fireDepartment: {
      value: 'fire-department',
      label: $t('kit:greateAmericanCover.fire_department')
    },
    lossData: {
      value: 'loss-data',
      label: $t('kit:greateAmericanCover.loss_data')
    },
    rewardCoverage: {
      value: 'reward-coverage',
      label: $t('kit:greateAmericanCover.reward_coverage')
    },
    pollutantCleanUp: {
      value: 'pollutant-clean-up',
      label: $t('kit:greateAmericanCover.pollutant_clean_up')
    },
    refrigerationBreakdown: {
      value: 'refrigeration-breakdown',
      label: $t('kit:greateAmericanCover.refrigeration_breakdown')
    },
    ownersGoodsExtension: {
      value: 'owners-goods-extension',
      label: $t('kit:greateAmericanCover.owners_goods_extension')
    },
    ownersGoodsExtensionNumber: {
      value: 'owners-goods-extension-number',
      label: $t('kit:greateAmericanCover.owners_goods_extension_number')
    },
    nonOwnedTrailer: {
      value: 'non-owned-trailer',
      label: $t('kit:greateAmericanCover.container_coverage')
    },
    nonOwnedTrailerNumber: {
      value: 'non-owned-trailer-number',
      label: $t('kit:greateAmericanCover.non-owned_trailer_number')
    },
    nonOwnedTrailerLimit: {
      value: 'non-owned-trailer-limit',
      label: $t('kit:greateAmericanCover.non-owned_trailer_limit')
    },
    reusablePackingContainers: {
      value: 'reusable-packing-containers',
      label: $t('kit:greateAmericanCover.reusable_packing_containers')
    },
    reusablePackingContainersLimit: {
      value: 'reusable-packing-containers-limit',
      label: $t('kit:greateAmericanCover.reusable_packing_containers_limit')
    },
    tarpsChains: {
      value: 'tarps-chains',
      label: $t('kit:greateAmericanCover.moving_equipment')
    },
    tarpsChainsLimit: {
      value: 'tarps-chains-limit',
      label: $t('kit:greateAmericanCover.tarps_chains_limit')
    },
    subhaulerOwnerPperator: {
      value: 'subhauler-owner-operator',
      label: $t('kit:greateAmericanCover.subhauler_or_owner_operator')
    }
  };
};
export var getGreateAmericanCoverList = function getGreateAmericanCoverList() {
  return Object.values(getGreateAmericanCoverMap());
};